import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchCallerByCallerId = async (callerId: string) => {
  const response = await queryExecute({
    variables: {
      callerId,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query CallerByCallerId($callerId: String!) {
        callerByCallerId(callerId: $callerId) {
          id
          createdAt
        }
      }
    `),
  });

  return response.data.callerByCallerId;
};
